goog.provide("shadow.js.shim.module$dayjs$locale$ru");
goog.provide("module$shadow_js_shim_module$dayjs$locale$ru");
shadow.js.shim.module$dayjs$locale$ru = shadow.js.nativeProvides["dayjs/locale/ru"] = require("dayjs/locale/ru");
module$shadow_js_shim_module$dayjs$locale$ru.default = shadow.js.shim.module$dayjs$locale$ru;
